import { Controller } from "@hotwired/stimulus"

// 은행 선택 모달 컨트롤러
export default class extends Controller {
  static targets = ["modal", "input", "selectedBank"]

  openModal(event) {
    event.preventDefault()
    this.modalTarget.showModal()
  }

  closeModal() {
    this.modalTarget.close()
  }

  selectBank(event) {
    const bank = event.currentTarget.dataset.bank

    // hidden input 업데이트
    this.inputTarget.value = bank

    // 선택된 은행 표시
    this.selectedBankTarget.textContent = bank
    this.selectedBankTarget.classList.remove('text-gray-400')
    this.selectedBankTarget.classList.add('text-gray-900')

    // 모달 닫기
    this.closeModal()
  }
}
